import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { StaffAuthService } from '../../staff/staff-auth.service';
import { StaffAccountsService } from '../../staff/api-services/staff-accounts.service';
import { IStaffAccountDto } from '../../interfaces/dtos/staff/IStaffAccountDto';

export const getStaffAccountFromImpersonationResolver: ResolveFn<IStaffAccountDto | null> = async () => {
  const staffAuthService = inject(StaffAuthService);
  const staffAccountService = inject(StaffAccountsService);
  const staffAuthToken = staffAuthService.GetAuthToken();

  if (staffAuthToken !== null) {
    return await new Promise<IStaffAccountDto | null>(resolve => {
      staffAccountService.GetCurrentAccount().subscribe({
        next: apiResponse => {
          return resolve(apiResponse.Data);
        },
        error: () => {
          return resolve(null);
        }
      });
    });
  }

  return null;
};
